import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { translations } from '@/translations';

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState('en');

  const t = useCallback((path) => {
    const keys = path.split('.');
    let result = translations[lang];
    for (const key of keys) {
      result = result?.[key];
    }
    return result || path;
  }, [lang]);

  const dir = translations[lang]?.dir || 'ltr';
  const isRTL = dir === 'rtl';

  // Set dir attribute on html element for proper RTL/LTR layout
  useEffect(() => {
    document.documentElement.dir = dir;
    document.documentElement.lang = lang;
  }, [dir, lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, dir, isRTL, languages: Object.keys(translations).map(k => ({ code: k, label: translations[k].label })) }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
